import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * Renders standard Open Graph + Twitter Card tags via react-helmet-async.
 * Values should already use absolute image/url strings (see utils/seoMeta).
 */
const SeoHelmet = ({
  title,
  description,
  image,
  url,
  type = 'website',
  siteName = 'Faster Link',
  keywords,
  author,
  language,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      {description ? <meta name="description" content={description} /> : null}
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {author ? <meta name="author" content={author} /> : null}
      <meta name="robots" content="index, follow" />
      {language ? <meta name="language" content={language} /> : null}

      <meta property="og:title" content={title || ''} />
      <meta property="og:description" content={description || ''} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url || ''} />
      <meta property="og:image" content={image || ''} />
      <meta property="og:image:secure_url" content={image || ''} />
      <meta property="og:image:alt" content={title || ''} />
      <meta property="og:site_name" content={siteName} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || ''} />
      <meta name="twitter:description" content={description || ''} />
      <meta name="twitter:image" content={image || ''} />

      {url ? <link rel="canonical" href={url} /> : null}
    </Helmet>
  );
};

export default SeoHelmet;
